import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Resolve uploaded media (`/api/uploads/...`) to a full backend URL. */
export function resolveMediaUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const api = axios.create({ baseURL: API, timeout: 90000 });

export async function fetchMachines() {
  const { data } = await api.get("/machines");
  return data.machines || [];
}
export async function fetchMachine(slug) {
  const { data } = await api.get(`/machines/${slug}`);
  return data;
}
export async function fetchBlog() {
  const { data } = await api.get("/blog");
  return data.articles || [];
}
export async function fetchArticle(slug) {
  const { data } = await api.get(`/blog/${slug}`);
  return data;
}
export async function fetchCases() {
  const { data } = await api.get("/cases");
  return data.cases || [];
}
export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}
export async function assistantChat(session_id, message) {
  const { data } = await api.post("/assistant/chat", { session_id, message });
  return data;
}
